<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p51"><span><a id="page_39"></a><a href="#/Contents#rp51">THREE-ONION SOUP WITH MUSHROOMS</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Mushrooms are a flavorful addition to this onion soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>3 cups thinly sliced onions</span></p>
<p class="hang"><span>1½ cups thinly sliced leeks</span></p>
<p class="hang"><span>½ cup chopped shallots or green onions</span></p>
<p class="hang"><span>1 tablespoon margarine or butter</span></p>
<p class="hang"><span>1 teaspoon sugar</span></p>
<p class="hang"><span>2 cups sliced mushrooms</span></p>
<p class="hang"><span>6½ cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Cook onions, leeks, and shallots in margarine in large saucepan, covered, over medium-low heat until onions are softened, about 15 minutes. Stir in sugar; cook, uncovered, until onion mixture is golden, about 15 minutes. Stir in mushrooms; cook over medium heat until tender, about 5 minutes. Add broth and heat to boiling; reduce heat and simmer, uncovered, 15 minutes. Season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 119</span></p>
<p class="per1"><span>% calories from fat: 21</span></p>
<p class="per1"><span>Protein (g): 2.7</span></p>
<p class="per1"><span>Carbohydrate (g): 18.5</span></p>
<p class="per1"><span>Fat (g): 3</span></p>
<p class="per1"><span>Saturated fat (g): 0.5</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 218</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 3.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0232.vue?7ca66f16